import { forwardRef, ForwardedRef } from 'react';
import classnames from 'classnames';

import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import ChipContent from '@hh.ru/magritte-ui-chips/ChipContent';
import { CheckableChipProps } from '@hh.ru/magritte-ui-chips/types';

import styles from './chips.less';

const STYLE_TO_CSS = {
    neutral: styles.chipStyleNeutral,
    accent: styles.chipStyleAccent,
};

const CheckableChipComponent = (
    {
        style = 'neutral',
        type = 'checkbox',
        addon,
        postfix,
        hideLabel,
        children,
        disabled,
        'aria-label': ariaLabel,
        dataQaWrapper = 'chip',
        size = 'medium',
        mode = 'primary',
        ...inputProps
    }: CheckableChipProps,
    ref: ForwardedRef<HTMLLabelElement>
) => {
    const forceDisabled = useDisabled();
    const isComponentDisabled = disabled || forceDisabled;

    return (
        <label
            className={classnames(styles.chip, STYLE_TO_CSS[style], {
                [styles.sizeSmall]: size === 'small',
                [styles.chipSecondary]: mode === 'secondary',
            })}
            ref={ref}
            data-qa={dataQaWrapper}
            data-interactive={true}
        >
            <input {...inputProps} type={type} className={styles.input} disabled={isComponentDisabled} />
            <ChipContent
                size={size}
                postfix={postfix}
                addon={addon}
                aria-label={ariaLabel}
                hideLabel={hideLabel}
                mode={mode}
            >
                {children}
            </ChipContent>
        </label>
    );
};

const CheckableChip = forwardRef(CheckableChipComponent);
export { CheckableChip };
